import Navbar from '../components/MyNavbar';
import Footer from '../components/Footer';
import { Outlet, useLocation } from 'react-router-dom';
import { useLayoutEffect } from 'react';
const links = {
    services: [
        { name: "Custom Software Development", slug: "software-engineering" },
        // { name: "Embedded System Development", slug: "#embedded-system-development" },
        // { name: "Hardware Design", slug: "#hardware-design" },
        // { name: "Early Stage Innovation", slug: "#early-stage-innovation" },
        { name: "UX/UI Design", slug: "software-engineering#ui-ux" },
        { name: "Front End", slug: "software-engineering#frontend" },
        { name: "Back Еnd", slug: "software-engineering#backend" },
        { name: "Quality Assurance", slug: "software-engineering#sqa" },
        { name: "Maintenance and Support", slug: "software-engineering#ams" },
        // { name: "Digital Transformation", slug: "#digital-transformation" },
        { name: "Business Analysis", slug: "management-consultancy" },
        { name: "3D printing and designing", slug: "3d-design-print" },
    ],
    solutions: [
        { name: "IoT", slug: "iot" },
        { name: "Industrial Automation", slug: "industry-solutions" },
        { name: "Electrical Engineering", slug: "electrical-engineering" },
        // { name: "Computer Vision", slug: "#computer-vision" },
        // { name: "AI/Machine Learning", slug: "#aimachine-learning" },
        // { name: "Planning & Architect", slug: "#planning-and-architect" },
        { name: "Mobile Development", slug: "software-engineering" },
        { name: "Web Development", slug: "software-engineering" },
    ],
    industries: [
        { name: "Courier service", slug: "iot#courier" },
        { name: "Healthcare", slug: "iot#health" },
        { name: "Transport", slug: "iot#transport" },
        // { name: "Consumer Electronics", slug: "#consumer-electronics" },
        { name: "Software and Technology", slug: "software-engineering" },
        { name: "Industrial Manufacturing", slug: "industry-solutions" },
        // { name: "Transportation", slug: "iot" },
        // { name: "Automotive", slug: "iot#automotive" },
        { name: "Cloud Solutions", slug: "software-engineering#cloud" }
    ]
};
export default function Layout() {
    const location = useLocation();
    useLayoutEffect(() => {
        document.documentElement.scrollTo(0, 0);
    }, [location.pathname]);
    return (
        <>
            <Navbar brand="Driesspace" links={links} />
            <div className="pages">
                <Outlet />
            </div>
            <Footer />
        </>
    )
}